import { TileLayer } from "react-leaflet"
import "./map-tiles.css"

// Растровые тайлы 2ГИС: границы по законодательству РФ, ключ не нужен
const DGIS_TILE_URL = 'https://tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1'

export const MAP_MAX_ZOOM = 16

// Тёмной темы у 2ГИС нет — светлые тайлы инвертируем CSS-фильтром (класс map-tiles-dark)
export const MapTiles = () => (
    <TileLayer
        url={DGIS_TILE_URL}
        subdomains={['0', '1', '2', '3']}
        attribution='&copy; <a href="https://2gis.ru" target="_blank" rel="noreferrer">2ГИС</a>'
        className="map-tiles-dark"
        maxZoom={MAP_MAX_ZOOM}
    />
)
